import classNames from 'classnames';
import Image, {
  Props as ImageProps
} from '../../Atoms/Image';

import bgDefault from '../../../assets/img/card-share-bg.png';
import imgModel from '../../../assets/img/card-share-model-new.png';

import Button, {
  Props as ButtonProps
} from '../../Atoms/Button';
import Title from '../../Atoms/Title';
import Text from '../../Atoms/Text';

interface Props {
  bgImg?: ImageProps;
  title?: string;
  subTitle?: string;
  shadow?: boolean;
  inline?: boolean;
  button?: ButtonProps;
}

function CardShare({
  bgImg,
  title,
  subTitle,
  shadow = true,
  inline = false,
  button
}: Props) {
  return (
    <div className="@container">
      <div
        className={classNames([
          shadow && 'shadow-card-share',
          !inline && 'pt-12 @3xl:min-h-[320px]',
          inline && '@2xl:min-h-[260px]',
          'relative flex'
        ])}
      >
        <div
          className={classNames([
            'relative z-0 flex grow items-center overflow-hidden rounded-xl @xl:pr-48',
            !inline && '@3xl:pr-72',
            inline && '@3xl:pr-56'
          ])}
        >
          <Image
            src={bgImg?.src || bgDefault}
            className="absolute inset-0 h-full w-full object-cover"
          />
          <div
            className="absolute inset-0 z-10"
            style={{
              backgroundImage:
                'linear-gradient(90deg,#0E1C6B 0%,rgba(37,40,93,0.01) 99%,rgba(37,40,93,0) 100%)'
            }}
          />
          <div className="relative z-20">
            <div
              className={classNames([
                !inline && 'py-10 px-7 md:p-14',
                inline && 'p-4 @lg:p-8'
              ])}
            >
              {title && (
                <Title
                  as="h4"
                  weight={900}
                  color="white"
                  className="mb-3 @3xl:mb-6"
                >
                  {title}
                </Title>
              )}
              {subTitle && (
                <Text
                  color="white"
                  size="base"
                  className="mb-3 @3xl:mb-6"
                >
                  {subTitle}
                </Text>
              )}
              {button && <Button {...button} />}
            </div>
          </div>
        </div>
        <div
          className={classNames([
            'absolute right-0 bottom-0 hidden @xl:block @xl:w-48',
            !inline && '@3xl:w-72',
            inline && '@3xl:w-56'
          ])}
        >
          <Image src={imgModel} alt="male model" />
        </div>
      </div>
    </div>
  );
}

export default CardShare;
